var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15393 7.48008C7.73088 6.21314 8.5563 5.30305 9.37794 4.66006H0.551758L0.551758 3.34006H9.37794C8.5563 2.69707 7.73088 1.78698 7.15393 0.520037L8.44311 6.10352e-05C9.45834 2.22939 11.4153 3.08133 12.2401 3.34006V4.66006C11.4153 4.9188 9.45834 5.77073 8.44311 8.00006L7.15393 7.48008Z",
    fill: "#E7E6E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5828a48eacb69151c71b393ed08ce2f3.svg";
export { ForwardRef as ReactComponent };